import { createReducer, on } from '@ngrx/store';

import { DoubleBetPrevention } from '../../../model/double-bet-prevention';
import { BetslipPlaceBetActions } from '../actions';
import { defaultBetslipPlaceBetState } from '../state';

export const placeBetReducer = createReducer(
    defaultBetslipPlaceBetState,
    on(BetslipPlaceBetActions.startedPlaceBet, (state, action) => {
        // Reset double bet prevention after request is initiated.
        return {
            ...state,
            doubleBetPrevention: DoubleBetPrevention.PreventIfSameOdds,
        };
    }),
    on(BetslipPlaceBetActions.disableDoubleBetPrevention, (state, action) => {
        // Disable double bet prevention
        return {
            ...state,
            doubleBetPrevention: DoubleBetPrevention.Disabled,
        };
    }),
    on(BetslipPlaceBetActions.saveBetInProgress, (state, action) => {
        return {
            ...state,
            betInProgress: action.payload,
        };
    }),
    on(BetslipPlaceBetActions.removeBetInProgress, (state, action) => {
        return {
            ...state,
            betInProgress: null,
        };
    }),
    on(BetslipPlaceBetActions.setPreBetStatus, (state, { bettingStatus }) => ({
        ...state,
        preBetStatus: bettingStatus,
    })),
);
